// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-09-02T08:51:20.481Z",
  gitInfo: {
    dirty: false,
    raw: "7596ceaf1",
    hash: "7596ceaf1",
    distance: null,
    tag: null,
    semver: null,
    suffix: "7596ceaf1",
    semverString: null
  }
};
/* tslint:enable */
